/* KinderSpeech 2.0 - Angle 3 (advertorial + listicle) kozos scroll-reveal.
   Progressive enhancement: nem kritikus. Ha nem tolt be, a tartalom akkor is
   latszik (a .ksrev--js osztaly nelkul a CSS semmit nem rejt el). */
(function () {
  function init() {
    var roots = document.querySelectorAll('.ksrev');
    if (!roots.length) return;

    roots.forEach(function (root) {
      root.classList.add('ksrev--js');
      var items = root.querySelectorAll('[data-reveal]');

      if (!('IntersectionObserver' in window)) {
        for (var i = 0; i < items.length; i++) items[i].classList.add('is-visible');
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });

      items.forEach(function (el) { io.observe(el); });
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();